import lrNum from './_src/lrNum.vue'
lrNum.install = function(Vue) {
  Vue.component(lrNum.name, lrNum)
}
export default lrNum